import { FirebaseError } from 'firebase/app';
import {
  collection,
  getCountFromServer,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
} from 'firebase/firestore';

import { db } from '../../config';

export const fetchPaginatedCollection = async <T>(
  collectionPath: string,
  page: number,
  pageSize: number,
  orderField: keyof T,
): Promise<{ data: T[]; totalPages: number }> => {
  const collectionRef = collection(db, collectionPath); // Untyped Firestore collection

  const countSnapshot = await getCountFromServer(collectionRef);
  const totalDocuments = countSnapshot.data().count;

  const totalPages = Math.ceil(totalDocuments / pageSize);

  if (page > totalPages || page < 1) {
    throw new FirebaseError('invalid-argument', `Invalid page number: ${page}`);
  }

  let startAfterDoc = null;

  if (page > 1) {
    const offset = (page - 1) * pageSize;
    const queryForStartDoc = query(collectionRef, orderBy(orderField as string, 'asc'), limit(offset));
    const offsetSnapshot = await getDocs(queryForStartDoc);

    startAfterDoc = offsetSnapshot.docs[offsetSnapshot.docs.length - 1];
  }

  const paginatedQuery = startAfterDoc
    ? query(collectionRef, orderBy(orderField as string, 'asc'), startAfter(startAfterDoc), limit(pageSize))
    : query(collectionRef, orderBy(orderField as string, 'asc'), limit(pageSize));

  const snapshot = await getDocs(paginatedQuery);
  return {
    data: snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as unknown as T[],
    totalPages,
  };
};
